<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="直播批次" prop="liveBatchName">
            <el-select v-model="searchForm.liveBatchName" filterable multiple collapse-tags clearable @change="categoryDetailChange">
              <el-option v-show="!all2" label="全部" value=""></el-option>
              <el-option v-show="all2" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in liveBatchNameList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺" prop="storeName">
            <el-select v-model="searchForm.storeName" filterable multiple collapse-tags clearable @change="storeChange">
              <el-option v-show="!all" label="全部" value=""></el-option>
              <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in storeNameList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品编码" prop="goodsCode">
            <el-input v-model="searchForm.goodsCode" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input v-model.trim="searchForm.goodsName" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="电商单号" prop="orderCode">
            <el-input v-model="searchForm.orderCode" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="平台单号" prop="platformOrderCode">
            <el-input v-model="searchForm.platformOrderCode" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="付款时间" prop="payTimeQuery">
            <el-date-picker
              v-model="searchForm.payTimeQuery"
              unlink-panels
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="配送状态" prop="orderDistributeFlowStatusName">
            <el-select v-model="searchForm.orderDistributeFlowStatusName" filterable multiple collapse-tags clearable @change="orderDistributeFlowStatusNameChange">
              <el-option v-show="!all3" label="全部" value=""></el-option>
              <el-option v-show="all3" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in deliveryStatusList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核时间" prop="soAuditTimeQuery">
            <el-date-picker
              v-model="searchForm.soAuditTimeQuery"
              unlink-panels
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="开单时间" prop="soTimeQuery">
            <el-date-picker
              v-model="searchForm.soTimeQuery"
              unlink-panels
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="配车时间" prop="withcarTimeQuery">
            <el-date-picker
              v-model="searchForm.withcarTimeQuery"
              unlink-panels
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发货时间" prop="transportTimeQuery">
            <el-date-picker
              v-model="searchForm.transportTimeQuery"
              unlink-panels
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="签收时间" prop="signTimeQuery">
            <el-date-picker
              v-model="searchForm.signTimeQuery"
              unlink-panels
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="完工时间" prop="completionTimeQuery">
            <el-date-picker
              v-model="searchForm.completionTimeQuery"
              unlink-panels
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            {{ scope.row[item.columnName] | cellValFormat }}
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from "@/utils/tableMixin";
import axios from "@/utils/axiosInstance";
import { downloadFile } from "@/utils";
import moment from "moment";
export default {
  name: "LiveOrderDetails",
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "prePlanliveOrderDetail",
      columnData: [],
      loading: false,
      searchForm: {
        liveBatchName: [],
        storeName: [],
        goodsCode: "",
        goodsName: "",
        orderCode: "",
        platformOrderCode: "",
        payTimeQuery: [moment().subtract(2, 'months').format('YYYYMMDD'), moment().format('YYYYMMDD')],
        orderDistributeFlowStatusName: "",
        soAuditTimeQuery: [],
        soTimeQuery: [],
        withcarTimeQuery: [],
        transportTimeQuery: [],
        signTimeQuery: [],
        completionTimeQuery: [],
      },
      exportData: {},
      searchCollapse: false,
      queryCriteria: [],
      all: false,
      all2: false,
      all3: false,
      liveBatchNameList: [],
      storeNameList: [],
      deliveryStatusList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.columns();
    this.getLiveBatchName();
    this.getStoreName();
    this.getDeliveryStatus();
  },
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
      });
    },
    onSearchSum() {
      let { productCode, productName } = this.searchForm;
      let data = { ...this.currencyForm };
      data.reportCode = "planLiveOrderProductInfoSum";
      data.param = {
        productCode: productCode,
        productName: productName,
      };
      axios
        .post(`/ec-pc-api/custom/reports/data/planLiveOrderProductInfoSum`, data)
        .then((res) => {
          if (res.code == 200) {
            this.textNum = {
              actualSaleNum: res.data.list[0].actualSaleNum || 0,
              planAmount: res.data.list[0].planAmount || 0,
            };
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "liveBatchName", //直播批次
          val: this.searchForm.liveBatchName ? this.searchForm.liveBatchName : [],
          op: "in",
        },
        {
          attributeName: "storeName", //店铺
          val: this.searchForm.storeName ? this.searchForm.storeName : [],
          op: "in",
        },
        {
          attributeName: "goodsCode", //商品编码
          val: this.searchForm.goodsCode ? this.searchForm.goodsCode.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "goodsName", //商品名称
          val: this.searchForm.goodsName ? this.searchForm.goodsName : "",
          op: "like",
        },
        {
          attributeName: "orderCode", //电商单号
          val: this.searchForm.orderCode ? this.searchForm.orderCode.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "platformOrderCode", //平台单号
          val: this.searchForm.platformOrderCode ? this.searchForm.platformOrderCode.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "payTimeQuery", //付款时间
          val: this.searchForm.payTimeQuery ? this.searchForm.payTimeQuery : [],
          op: "range",
        },
        {
          attributeName: "orderDistributeFlowStatusName", //配送状态
          val: this.searchForm.orderDistributeFlowStatusName ? this.searchForm.orderDistributeFlowStatusName : [],
          op: "in",
        },
        {
          attributeName: "soAuditTimeQuery", //审核时间
          val: this.searchForm.soAuditTimeQuery ? this.searchForm.soAuditTimeQuery : [],
          op: "range",
        },
        {
          attributeName: "soTimeQuery", //开单时间
          val: this.searchForm.soTimeQuery ? this.searchForm.soTimeQuery : [],
          op: "range",
        },
        {
          attributeName: "withcarTimeQuery", //配车时间
          val: this.searchForm.withcarTimeQuery ? this.searchForm.withcarTimeQuery : [],
          op: "range",
        },
        {
          attributeName: "transportTimeQuery", //发货时间
          val: this.searchForm.transportTimeQuery ? this.searchForm.transportTimeQuery : [],
          op: "range",
        },
        {
          attributeName: "signTimeQuery", //签收时间
          val: this.searchForm.signTimeQuery ? this.searchForm.signTimeQuery : [],
          op: "range",
        },
        {
          attributeName: "completionTimeQuery", //完工时间
          val: this.searchForm.completionTimeQuery ? this.searchForm.completionTimeQuery : [],
          op: "range",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      this.$refs.searchForm.resetFields();
      let selectedList = this.deliveryStatusList.filter(v=> v!='已完工' && v!='(空白)')
      this.$set(this.searchForm,'orderDistributeFlowStatusName',selectedList)
      this.all = false;
      this.all2 = false;
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    storeChange(val) {
      this.all = this.storeNameList.length == val.length;
      if (val.includes("")) {
        this.searchForm.storeName = this.storeNameList;
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.storeName = [];
        this.all = false;
      }
    },
    categoryDetailChange(val) {
      this.all2 = this.liveBatchNameList.length == val.length;
      if (val.includes("")) {
        this.searchForm.liveBatchName = this.liveBatchNameList;
        this.all2 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.liveBatchName = [];
        this.all2 = false;
      }
    },
    orderDistributeFlowStatusNameChange(val) {
      this.all3 = this.deliveryStatusList.length == val.length;
      if (val.includes("")) {
        this.searchForm.orderDistributeFlowStatusName = this.deliveryStatusList;
        this.all3 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.orderDistributeFlowStatusName = [];
        this.all3 = false;
      }
    },

    //直播批次
    getLiveBatchName() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "liveBatchName";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.liveBatchNameList = data.filter(v=>v != '(空白)');
      });
    },
    //店铺
    getStoreName() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "storeName";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.storeNameList = data.filter(v=>v != '(空白)');
      });
    },
    //配送状态
    getDeliveryStatus() {
      this.loading = true
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "orderDistributeFlowStatusName";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.deliveryStatusList = data.filter(v=>v != '(空白)');
        let selectedList = this.deliveryStatusList.filter(v=> v!='已完工' && v!='(空白)')
        this.$set(this.searchForm,'orderDistributeFlowStatusName',selectedList)
        this.onSearch();
      });
    },

    handleSortChange({ column, prop, order }) {
      this.tableData.pageNum = 1;
      this.orderSort = {
        sortField: prop,
        sortOptions: order === "ascending" ? "0" : order === "descending" ? "1" : "",
      };
      this.init();
    },
    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: "string",
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != "图片"); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== "图片");
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>
